// import 'range-slider-element';
// import RangeSlider from '@spreadtheweb/multi-range-slider';

let propertySearchBlocks = $('.wp-block-pulp-property-search');

let nFormatter = function(num, digits) {
    let si = [{ value: 1, symbol: "" }, { value: 1E3, symbol: "k" }, { value: 1E6, symbol: "M" }, { value: 1E9, symbol: "G" }, { value: 1E12, symbol: "T" }, { value: 1E15, symbol: "P" }, { value: 1E18, symbol: "E" }],
        rx = /\.0+$|(\.[0-9]*[1-9])0+$/,
        i;

    for (i = si.length - 1; i > 0; i--) { if (num >= si[i].value) break; }

    return (num / si[i].value).toFixed(digits).replace(rx, "$1") + si[i].symbol;
}

let collision = function($div1, $div2) {
    let x1 = $div1.offset().left, w1 = 40, r1 = x1 + w1, x2 = $div2.offset().left, w2 = 40, r2 = x2 + w2;
    return (!(r1 < x2 || x1 > r2));
}

if(propertySearchBlocks.length) {
    propertySearchBlocks.each(function() {

        let $this = $(this),
            blockId = $this.data('block-id'),
            filterOptions = $(this).find('.filter-option'),
            filterOptionToggles = $(this).find('.filter-option-toggle'),
            searchInput = $(this).find('input[name="query"]'),
            currentView = 'map',
            mapViewToggle = $(this).find('.map-view-toggle'),
            gridViewToggle = $(this).find('.grid-view-toggle'),
            resultsRow = $(this).find('.results-row'),
            mobileFiltersToggle = $(this).find('.mobile-filters-toggle'),
            mobileFilters = $(this).find('.filters-row'),
            mobileFiltersDone = $(this).find('.mobile-filters-done'),
            priceSlider = $(this).find('.price-slider'),
            initialPriceMin = priceSlider.data('min'),
            initialPriceMax = priceSlider.data('max'),
            priceDropdownButton = $(this).find('.price-dropdown-button'),
            priceDropdownButtonMin = $(this).find('.price-dropdown-button-min'),
            priceDropdownButtonMax = $(this).find('.price-dropdown-button-max'),
            priceDropdownOptionsMin = $(this).find('.price-dropdown-option-min'),
            priceDropdownOptionsMax = $(this).find('.price-dropdown-option-max');

        priceDropdownButton.on('click', function(e) {
            e.preventDefault();
            if($(this).hasClass('active')) {
                $(this).removeClass('active');
                $(this).parent().find('.price-dropdown-options').slideUp();
            } else {
                $(this).addClass('active');
                $(this).parent().find('.price-dropdown-options').slideDown();
            }
        });

        priceDropdownOptionsMin.on('click', function (e) {
            e.preventDefault();
            priceSlider.slider('values', 0, $(this).data('value'));
            $(this).parent().slideUp();
            $(this).parent().closest('.price-dropdown-button').removeClass('active');
        });

        priceDropdownOptionsMax.on('click', function (e) {
            e.preventDefault();
            priceSlider.slider('values', 1, $(this).data('value'));
            $(this).parent().slideUp();
            $(this).parent().closest('.price-dropdown-button').removeClass('active');
        });

        mobileFiltersToggle.on('click', function(e) {
            if($(this).hasClass('active')) {
                $(this).removeClass('active');
                mobileFilters.slideUp();
            } else {
                $(this).addClass('active');
                mobileFilters.slideDown();
            }
        });

        mobileFiltersDone.on('click', function(e) {
            e.preventDefault();
            mobileFiltersToggle.removeClass('active');
            mobileFilters.slideUp();
            propertySearch();
        });

        mapViewToggle.on('click', function(e) {
            e.preventDefault();
            currentView = 'map';
            mapViewToggle.addClass('active');
            gridViewToggle.removeClass('active');
            resultsRow.removeClass('grid-view');
            propertySearch();
        });

        gridViewToggle.on('click', function(e) {
            e.preventDefault();
            currentView = 'grid';
            gridViewToggle.addClass('active');
            mapViewToggle.removeClass('active');
            resultsRow.addClass('grid-view');
            propertySearch();
        });

        if($(window).width() < 992) {
            gridViewToggle.trigger('click');
        }

        searchInput.on('keyup', function(event) {
            if(event.key === "Enter") {
                event.preventDefault();
            }

            propertySearch();
        });

        let priceSliderObj = priceSlider.slider({
            range: true,
            min: priceSlider.data('min'),
            max: priceSlider.data('max'),
            step: 100,
            values: [priceSlider.data('min'), priceSlider.data('max')],
            slide: function (event, ui) {

                // $('#home_price_search_high').val(ui.values[1]);
                // $('#home_price_search_low').val(ui.values[0]);

                priceSlider.find('.ui-slider-handle:eq(0) .price-range-min').html('> $' + nFormatter(ui.values[0], 1));
                priceSlider.find('.ui-slider-handle:eq(1) .price-range-max').html('< $' + nFormatter(ui.values[1], 1));
                $('.price-range-both').html('<i>$' + nFormatter(ui.values[0], 1) + ' - $' + nFormatter(ui.values[1], 1) + '</i>');

                if (ui.values[0] === ui.values[1]) {
                    $('.price-range-both i').css('display', 'none');
                } else {
                    $('.price-range-both i').css('display', 'inline');
                }

                if (collision($('.price-range-min'), $('.price-range-max')) == true) {
                    $('.price-range-min, .price-range-max').css('opacity', '0');
                    $('.price-range-both').css('display', 'block');
                } else {
                    $('.price-range-min, .price-range-max').css('opacity', '1');
                    $('.price-range-both').css('display', 'none');
                }

            }, stop: function (event, ui) {
                // TODO: filter label update
                // priceFilterLabel.html('$' + nFormatter(ui.values[0], 1) + ' - ' + '$' + nFormatter(ui.values[1], 1));
            }, change: function (event, ui) {
                priceSlider.find('.ui-slider-handle:eq(0) .price-range-min').html('> $' + nFormatter(ui.values[0], 1));
                priceSlider.find('.ui-slider-handle:eq(1) .price-range-max').html('< $' + nFormatter(ui.values[1], 1));
                $('.price-range-both').html('<i>$' + nFormatter(ui.values[0], 1) + ' - $' + nFormatter(ui.values[1], 1) + '</i>');

                if (ui.values[0] === ui.values[1]) {
                    $('.price-range-both i').css('display', 'none');
                } else {
                    $('.price-range-both i').css('display', 'inline');
                }

                if (collision($('.price-range-min'), $('.price-range-max')) == true) {
                    $('.price-range-min, .price-range-max').css('opacity', '0');
                    $('.price-range-both').css('display', 'block');
                } else {
                    $('.price-range-min, .price-range-max').css('opacity', '1');
                    $('.price-range-both').css('display', 'none');
                }

                priceDropdownButtonMin.find('.button-label').html(nFormatter(ui.values[0], 1));
                priceDropdownButtonMax.find('.button-label').html(nFormatter(ui.values[1], 1));

                propertySearch();
            }
        });

        priceSlider.find('.ui-slider-range').append('<span class="price-range-both value"><i style="display: none;">$' + nFormatter(parseInt(priceSliderObj.slider('values', 0)), 1) + ' - ' + nFormatter(parseInt(priceSliderObj.slider('values', 1)), 1) + '</i></span>');
        priceSlider.find('.ui-slider-handle:eq(0)').append('<span class="price-range-min value">> $' + nFormatter(parseInt(priceSliderObj.slider('values', 0)), 1) + '</span>');
        priceSlider.find('.ui-slider-handle:eq(1)').append('<span class="price-range-max value">< $' + nFormatter(parseInt(priceSliderObj.slider('values', 1)), 1) + '</span>');

        filterOptionToggles.on('click', function(e) {
            e.preventDefault();

            let filterOption = $(this).closest('.filter-option');

            if(filterOption.hasClass('active')) {
                filterOption.removeClass('active');
                filterOption.find('.filter-dropdown').slideUp();
            } else {
                filterOptions.not(filterOption).removeClass('active');
                filterOptions.not(filterOption).find('.filter-dropdown').slideUp();
                filterOption.addClass('active');
                filterOption.find('.filter-dropdown').slideDown();
            }
        });

        $('body').on('click', function(e) {
            if(!$(e.target).closest('.filter-option').length && !$(e.target).closest('.filter-option-toggle').length) {
                filterOptions.removeClass('active');
                filterOptions.find('.filter-dropdown').slideUp();
            }
        });

        filterOptions.find('input[type="checkbox"]').on('change', function() {
            propertySearch();
        });

        filterOptions.find('input[type="radio"]').on('change', function() {
            propertySearch();
        });

        filterOptions.find('button.filter-done').on('click', function(e) {
            e.preventDefault();
            let filterOption = $(this).closest('.filter-option');
            filterOption.removeClass('active');
            filterOption.find('.filter-dropdown').slideUp();
            propertySearch();
        });

        filterOptions.find('.clear-filter-button').on('click', function(e) {
            let filterOption = $(this).closest('.filter-option'),
                inputs = filterOption.find('input[type="checkbox"], input[type="radio"]');

            e.preventDefault();
            e.stopPropagation();
            inputs.prop('checked', false);

            if($(this).parent().parent().hasClass('price-option')) {
                priceSliderObj.slider('values', [initialPriceMin, initialPriceMax]);
            }

            propertySearch();
        });

        function propertySearch() {

            let query = '',
                selectedCities = [],
                selectedStatuses = [],
                selectedTypes = [],
                selectedBrokers = [],
                selectedSchoolDistricts = [],
                selectedLotTypes = [],
                selectedBedrooms = [],
                selectedPetPolicies = [],
                matchingResults = 0;

            if(searchInput.length) {
                query = searchInput.val().trim().toLowerCase();
            }

            $this.find('input[name="city"]:checked').each(function() {
                selectedCities.push($(this).val());
            });

            processFilterLabels();

            if(window.property_listings_search_type === 'commercial') {

                $this.find('input[name="status"]:checked').each(function() {
                    selectedStatuses.push($(this).val());
                });

                $this.find('input[name="type"]:checked').each(function() {
                    selectedTypes.push($(this).val());
                });

                $this.find('input[name="broker"]:checked').each(function() {
                    selectedBrokers.push($(this).val());
                });

            } else if(window.property_listings_search_type === 'residential') {

                $this.find('input[name="school-district"]:checked').each(function() {
                    selectedSchoolDistricts.push($(this).val());
                });

                $this.find('input[name="lot-type"]:checked').each(function() {
                    selectedLotTypes.push($(this).val());
                });

            } else if(window.property_listings_search_type === 'homes') {

                $this.find('input[name="type"]:checked').each(function() {
                    selectedTypes.push($(this).val());
                });

                // price

                $this.find('input[name="bedrooms"]:checked').each(function() {
                    selectedBedrooms.push($(this).val());
                });

            } else if(window.property_listings_search_type === 'apartments') {

                $this.find('input[name="bedrooms"]:checked').each(function() {
                    selectedBedrooms.push($(this).val());
                });

                $this.find('input[name="pet_policy"]:checked').each(function() {
                    selectedPetPolicies.push($(this).val());
                });

            }

            let mapListings = [];

            window.property_listings.forEach(function(property) {

                let matchesAll = true;

                let matchesQuery = property.title.toLowerCase().includes(query);
                if(!matchesQuery) matchesQuery = property.address.toLowerCase().includes(query);
                if (!matchesQuery) matchesAll = false;

                if(selectedCities.length > 0) {
                    let matchesCity = selectedCities.includes(property.city);
                    if (!matchesCity) matchesAll = false;
                }

                if(selectedStatuses.length > 0) {
                    let matchesStatus = selectedStatuses.includes(property.status);
                    if (!matchesStatus) matchesAll = false;
                }

                if(selectedTypes.length > 0) {
                    if (Array.isArray(property.type)) {
                        let matchesType = property.type.some(type => selectedTypes.includes(type));
                        if (!matchesType) matchesAll = false;
                    }
                }

                if(selectedBrokers.length > 0) {
                    if(Array.isArray(property.broker)) {
                        let matchesBroker = property.broker.some(broker => selectedBrokers.includes(broker));
                        if (!matchesBroker) matchesAll = false;
                    }
                }

                if(selectedSchoolDistricts.length > 0) {
                    let matchesSchoolDistrict = selectedSchoolDistricts.includes(property.school_district);
                    if (!matchesSchoolDistrict) matchesAll = false;
                }

                if(selectedLotTypes.length > 0) {
                    if(Array.isArray(property.lot_type)) {
                        let matchesLotType = property.lot_type.some(lot_type => selectedLotTypes.includes(lot_type));
                        if (!matchesLotType) matchesAll = false;
                    }
                }

                if(selectedBedrooms.length > 0) {
                    if(Array.isArray(property.lot_type) || typeof property.number_of_bedrooms === 'object') {
                        let matchesBedrooms = property.number_of_bedrooms.some(bedroom => selectedBedrooms.includes(bedroom));
                        if (!matchesBedrooms) matchesAll = false;
                    } else {
                        let matchesBedrooms = selectedBedrooms.includes(property.number_of_bedrooms);
                        if (!matchesBedrooms) matchesAll = false;
                    }
                }

                if(selectedPetPolicies.length > 0) {
                    let matchesPetPolicy = selectedPetPolicies.includes(property.pet_policy);
                    if (!matchesPetPolicy) matchesAll = false;
                }

                if(priceSliderObj && priceSliderObj.length) {
                    let minPrice = priceSliderObj.slider('values', 0),
                        maxPrice = priceSliderObj.slider('values', 1),
                        propertyLowPrice = parseInt(property.price_low.replace(/[^0-9.-]+/g, "")),
                        propertyHighPrice = parseInt(property.price_high.replace(/[^0-9.-]+/g, ""));

                    // if property.price_low contains "k" convert to full number
                    if(property.price_low.toLowerCase().includes('k')) {
                        console.log('Converting low price for', property.title);
                        propertyLowPrice = propertyLowPrice * 1000;
                    }

                    if(property.price_high.toLowerCase().includes('k')) {
                        console.log('Converting high price for', property.title);
                        propertyHighPrice = propertyHighPrice * 1000;
                    }

                    console.log(propertyLowPrice, propertyHighPrice, minPrice, maxPrice);

                    if(propertyHighPrice < minPrice || propertyLowPrice > maxPrice) {
                        matchesAll = false;
                    }
                }

                console.log('Property:', property.title, 'Matches All:', matchesAll);

                if(matchesAll) {
                    matchingResults++;
                    mapListings.push(property);
                    $('.listing-item-' + property.id).show();
                } else {
                    $('.listing-item-' + property.id).hide();
                }

            });

            // resultsRow.removeClass('listings-count')
            const classToRemove = Array.from(resultsRow[0].classList).find(className => className.startsWith('listings-count-'));
            if(classToRemove) {
                resultsRow.removeClass(classToRemove);
            }
            resultsRow.addClass('listings-count-' + matchingResults);



            let zoom = 12.5,
                windowWidth = $(window).width(),
                centerPoint = { lat: 43.5460, lng: -96.7313 };

            if(window.property_listings_search_type === 'apartments') {
                zoom = 11;
            }

            if(window.property_listings_search_type === 'residential') {
                zoom = 11.5;
            }

            if(window.property_listings_search_type === 'storage') {
                zoom = 9;
                //43.0990429090299, -97.360682885998
                centerPoint = { lat: 43.0990, lng: -97.3607 };
            }

            // if (windowWidth < 450) {
            //     zoom = 3.2;
            // } else if (windowWidth < 500) {
            //     zoom = 3.5;
            // } else if (windowWidth < 768) {
            //     zoom = 4;
            // } else if (windowWidth < 991) {
            //     zoom = 4.2;
            // } else if (windowWidth < 1200) {
            //     zoom = 4.5;
            // }
            if(currentView === 'map') {
                let map = new google.maps.Map(document.getElementById('property-search-map-' + blockId), {
                        center: centerPoint,
                        zoom: zoom,
                        // mapTypeControl: false,
                        // disableDefaultUI: true,
                        // mapTypeId: 'terrain'
                    }),
                    bounds = new google.maps.LatLngBounds(),
                    infoWindow = new google.maps.InfoWindow();

                // map.setOptions({ styles: window.helpers.defaultGoogleMapStyles });

                for( let i = 0; i < mapListings.length; i++) {

                    let property = mapListings[i],
                        latLng = new google.maps.LatLng(property.latitude, property.longitude),
                        marker = new google.maps.Marker({
                            position: latLng,
                            map: map,
                            title: property.title,
                            icon: '/wp-content/themes/pulp/assets/images/theme/icon-map-blue.png'
                        });

                    bounds.extend(latLng);

                    google.maps.event.addListener(marker, 'click', (function(marker, property) {
                        return function() {
                            if(window.property_listings_search_type === 'commercial') {
                                infoWindow.setContent('' +
                                    '<div class="info-window">' +
                                    '<h3 class="sub-heading-small color-cobalt">' + property.title + '</h3>' +
                                    '<p class="popup-price">' + property.price + '</p>' +
                                    '<p class="text-tight color-text">' + property.address + '</p>' +
                                    '<a href="' + property.link + '" class="link microtitle btn-arrow">Details <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                                    '<path d="M7.5 6.00008L6.90973 5.34045L2.12115 -2.35117e-07L0.500001 1.31922L4.69826 6L0.5 10.6808L2.12115 12L6.90973 6.65955L7.5 6.00008Z" fill="#E74B38"/>' +
                                    '</svg></a>' +
                                    '</div>' +
                                    '');
                            } else if(window.property_listings_search_type === 'residential') {
                                infoWindow.setContent('' +
                                    '<div class="info-window">' +
                                    '<h3 class="sub-heading-small color-cobalt">' + property.title + '</h3>' +
                                    // '<p class="popup-price">' + property.price + '</p>' +
                                    '<p class="text-tight color-text">' + property.address + '</p>' +
                                    '<a href="' + property.link + '" class="link microtitle btn-arrow">Details <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                                    '<path d="M7.5 6.00008L6.90973 5.34045L2.12115 -2.35117e-07L0.500001 1.31922L4.69826 6L0.5 10.6808L2.12115 12L6.90973 6.65955L7.5 6.00008Z" fill="#E74B38"/>' +
                                    '</svg></a>' +
                                    '</div>' +
                                    '');
                            } else {
                                infoWindow.setContent('' +
                                    '<div class="info-window">' +
                                    '<h3 class="sub-heading-small color-cobalt">' + property.title + '</h3>' +
                                    '<p>' + property.address + '</p>' +
                                    '<a href="' + property.link + '">Details <svg width="10" height="8" viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                                    '<path d="M9.77882 3.45061L6.69449 0.222994C6.41036 -0.0743329 5.93668 -0.0743328 5.65255 0.222994C5.36842 0.520321 5.36842 1.01601 5.65255 1.31334L7.47372 3.23023L0.736846 3.23024C0.326486 3.23024 5.66556e-07 3.57189 6.04098e-07 4.00131C6.41639e-07 4.43073 0.326486 4.77239 0.736846 4.77239L7.47372 4.77239L5.65255 6.67816C5.36842 6.97548 5.36842 7.47117 5.65255 7.7685C5.79975 7.92254 5.98931 8 6.17887 8C6.36843 8 6.55799 7.92298 6.70519 7.7685L9.77878 4.55212C9.9157 4.40884 10 4.21047 10 4.00135C10 3.79224 9.9264 3.59387 9.77878 3.45059L9.77882 3.45061Z" fill="#DA311B"/>\n' +
                                    '</svg></a>' +
                                    '</div>' +
                                    '');
                            }
                            marker.setIcon('/wp-content/themes/pulp/assets/images/theme/icon-map-steel.png');
                            infoWindow.open(map, marker);
                        };
                    })(marker, property));

                    // on close of the map marker, reset the icon
                    google.maps.event.addListener(infoWindow, 'closeclick', function() {
                        marker.setIcon('/wp-content/themes/pulp/assets/images/theme/icon-map-blue.png');
                    });

                    $('.listing-item-' + property.id).on('mouseenter', function(e) {
                        e.preventDefault();
                        marker.setIcon('/wp-content/themes/pulp/assets/images/theme/icon-map-steel.png');
                    });

                    $('.listing-item-' + property.id).on('mouseleave', function(e) {
                        e.preventDefault();
                        marker.setIcon('/wp-content/themes/pulp/assets/images/theme/icon-map-blue.png');
                    });

                }
            }

        }

        function processFilterLabels() {

            filterOptions.each(function() {

                let filterOption = $(this),
                    originalLabel = filterOption.data('original-label'),
                    label = filterOption.find('.filter-option-toggle').find('.label'),
                    options = filterOption.find('input[type="checkbox"]'),
                    radios = filterOption.find('input[type="radio"]');

                let selectedOptions = options.filter(':checked'),
                    selectedRadios = radios.filter(':checked'),
                    selectedCount = selectedOptions.length,
                    selectedRadioCount = selectedRadios.length;

                if(selectedCount === 0 && selectedRadioCount === 0) {
                    label.text(originalLabel);
                    filterOption.removeClass('has-selected');
                } else {
                    let labelText = '';
                    filterOption.addClass('has-selected');

                    if(selectedCount === 1) {
                        labelText = selectedOptions.first().val();
                    } else if(selectedCount > 1) {
                        labelText = selectedOptions.first().val() + ', +' + (selectedCount - 1);
                    } else if(selectedRadioCount === 1) {
                        labelText = selectedRadios.first().val();
                    } else if(selectedRadioCount > 1) {
                        labelText = selectedRadios.first().val() + ', +' + (selectedRadioCount - 1);
                    }

                    // selectedOptions.each(function() {
                    //     if(labelText.length > 0) {
                    //         labelText += ', ';
                    //     }
                    //     labelText += $(this).val();
                    //     console.log($(this).val());
                    // });
                    //
                    // if(labelText.length > 20) {
                    //     labelText = labelText.substring(0, 20) + '...';
                    // }
                    label.text(labelText);
                }

                if(priceSliderObj && priceSliderObj.length) {
                    if($(this).hasClass('price-option')) {
                        let minPrice = priceSliderObj.slider('values', 0),
                            maxPrice = priceSliderObj.slider('values', 1);

                        if(minPrice === initialPriceMin && maxPrice === initialPriceMax) {
                            label.text(originalLabel);
                            filterOption.removeClass('has-selected');
                        } else {
                            label.text('$' + nFormatter(minPrice, 1) + ' - $' + nFormatter(maxPrice, 1));
                            filterOption.addClass('has-selected');
                        }
                    }
                }

                //     selectedCount = dropdown.find('input[type="checkbox"]:checked').length;
                //
                // if(selectedCount > 0) {
                //     label.text(label.data('label-selected').replace('%count%', selectedCount));
                // } else {
                //     label.text(label.data('label-default'));
                // }
            });

        }

        propertySearch();

    });
}

let brochureLinks = $('.listing-brochure button');

if(brochureLinks.length) {

    brochureLinks.on('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        let link = $(this).data('link'),
            target = $(this).data('target');

        if(link) {
            window.open(link, target || '_blank');
        }
    });
}

/*
 *   This content is licensed according to the W3C Software License at
 *   https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
 *
 *   File:   slider-multithumb.js
 *
 *   Desc:   A dual slider widget that implements ARIA Authoring Practices
 */

'use strict';

class SliderMultithumb {
    constructor(domNode) {
        this.isMoving = false;
        this.movingSliderNode = false;

        this.domNode = domNode;

        this.svgNode = domNode.querySelector('svg');
        this.svgPoint = this.svgNode.createSVGPoint();

        this.railNode = domNode.querySelector('.rail rect');
        this.rangeNode = domNode.querySelector('.range rect');

        this.minSliderPosition = 0;
        this.maxSliderPosition = 0;

        this.minSliderNode = domNode.querySelector('[role=slider].minimum');
        this.maxSliderNode = domNode.querySelector('[role=slider].maximum');

        this.minSliderValueNode = this.minSliderNode.querySelector('.value');
        this.maxSliderValueNode = this.maxSliderNode.querySelector('.value');

        this.minSliderFocusNode = this.minSliderNode.querySelector('.focus-ring');
        this.maxSliderFocusNode = this.maxSliderNode.querySelector('.focus-ring');

        this.minSliderThumbNode = this.minSliderNode.querySelector('.thumb');
        this.maxSliderThumbNode = this.maxSliderNode.querySelector('.thumb');

        // Dimensions of the slider focus ring, thumb and rail

        this.svgWidth = 360;
        this.svgHeight = 100;

        this.valueTop = 24;
        this.valueHeight = this.minSliderValueNode.getBoundingClientRect().height;

        this.railHeight = 6;
        this.railWidth = 300;
        this.railY = 42;
        this.railX = 10;

        this.thumbTop = 31;
        this.thumbHeight = 28;
        this.thumbWidth = 28;
        this.thumb2Width = 2 * this.thumbWidth;
        this.thumbMiddle = this.thumbTop + this.thumbHeight / 2;
        this.thumbBottom = this.thumbTop + this.thumbHeight;

        this.focusOffset = 8;
        this.focusY = this.valueTop - this.valueHeight - this.focusOffset + 2;
        this.focusWidth = this.thumbWidth + 2 * this.focusOffset;
        this.focusHeight = this.thumbBottom - this.focusY + this.focusOffset + 2;
        this.focusRadius = this.focusWidth / 8;

        this.svgNode.setAttribute('width', this.svgWidth);
        this.svgNode.setAttribute('height', this.svgHeight);

        this.minSliderFocusNode.setAttribute('y', Math.max(2, this.focusY));
        this.maxSliderFocusNode.setAttribute('y', Math.max(2, this.focusY));
        this.minSliderFocusNode.setAttribute('width', this.focusWidth);
        this.maxSliderFocusNode.setAttribute('width', this.focusWidth);
        this.minSliderFocusNode.setAttribute('height', this.focusHeight);
        this.maxSliderFocusNode.setAttribute('height', this.focusHeight);
        this.minSliderFocusNode.setAttribute('rx', this.focusRadius);
        this.maxSliderFocusNode.setAttribute('rx', this.focusRadius);

        this.minSliderValueNode.setAttribute('y', this.valueTop);
        this.maxSliderValueNode.setAttribute('y', this.valueTop);

        this.railNode.setAttribute('y', this.railY);
        this.railNode.setAttribute('x', this.railX);
        this.railNode.setAttribute('height', this.railHeight);
        this.railNode.setAttribute('width', this.railWidth + this.thumbWidth);
        this.railNode.setAttribute('rx', this.railHeight / 2);

        this.rangeNode.setAttribute('y', this.railY);
        this.rangeNode.setAttribute('x', this.railX / 2);
        this.rangeNode.setAttribute('height', this.railHeight);
        this.rangeNode.setAttribute('width', 0);

        this.sliderMinValue = this.getValueMin(this.minSliderNode);
        this.sliderMaxValue = this.getValueMax(this.maxSliderNode);
        this.sliderDiffValue = this.sliderMaxValue - this.sliderMinValue;

        this.minSliderRight = 0;
        this.maxSliderLeft = this.railWidth;

        this.minSliderNode.addEventListener(
            'keydown',
            this.onSliderKeydown.bind(this)
        );
        this.minSliderNode.addEventListener(
            'pointerdown',
            this.onSliderPointerdown.bind(this)
        );

        this.minSliderNode.addEventListener('focus', this.onSliderFocus.bind(this));
        this.minSliderNode.addEventListener('blur', this.onSliderBlur.bind(this));

        this.maxSliderNode.addEventListener(
            'keydown',
            this.onSliderKeydown.bind(this)
        );
        this.maxSliderNode.addEventListener(
            'pointerdown',
            this.onSliderPointerdown.bind(this)
        );

        // bind a pointermove event handler to move pointer
        document.addEventListener('pointermove', this.onPointermove.bind(this));

        // bind a pointerup event handler to stop tracking pointer movements
        document.addEventListener('pointerup', this.onPointerup.bind(this));

        this.maxSliderNode.addEventListener('focus', this.onSliderFocus.bind(this));
        this.maxSliderNode.addEventListener('blur', this.onSliderBlur.bind(this));

        this.railNode.addEventListener('click', this.onRailClick.bind(this));

        this.moveSliderTo(this.minSliderNode, this.getValue(this.minSliderNode));
        this.moveSliderTo(this.maxSliderNode, this.getValue(this.maxSliderNode));
    }

    getSVGPoint(event) {
        this.svgPoint.x = event.clientX;
        this.svgPoint.y = event.clientY;
        return this.svgPoint.matrixTransform(this.svgNode.getScreenCTM().inverse());
    }

    getValue(sliderNode) {
        return parseInt(sliderNode.getAttribute('aria-valuenow'));
    }

    getValueMin(sliderNode) {
        return parseInt(sliderNode.getAttribute('aria-valuemin'));
    }

    getValueMax(sliderNode) {
        return parseInt(sliderNode.getAttribute('aria-valuemax'));
    }

    isMinSlider(sliderNode) {
        return this.minSliderNode === sliderNode;
    }

    isInRange(sliderNode, value) {
        const valueMin = this.getValueMin(sliderNode);
        const valueMax = this.getValueMax(sliderNode);
        return value <= valueMax && value >= valueMin;
    }

    isOutOfRange(value) {
        const valueMin = this.getValueMin(this.minSliderNode);
        const valueMax = this.getValueMax(this.maxSliderNode);
        return value > valueMax || value < valueMin;
    }

    getXFromThumb(node) {
        const points = node.getAttribute('points').split(',');
        return parseInt(points[0]);
    }

    moveSliderTo(sliderNode, value) {
        let valueMax;
        let valueMin;
        let pos;
        let points = '';
        let x;
        let width;

        if (this.isMinSlider(sliderNode)) {
            valueMin = this.getValueMin(this.minSliderNode);
            valueMax = this.getValueMax(this.minSliderNode);
        } else {
            valueMin = this.getValueMin(this.maxSliderNode);
            valueMax = this.getValueMax(this.maxSliderNode);
        }

        value = Math.min(Math.max(value, valueMin), valueMax);

        sliderNode.setAttribute('aria-valuenow', value);
        const dollarValue = `$${value}`;

        pos = this.railX;
        pos += Math.round(
            (value * (this.railWidth - this.thumbWidth)) /
            (this.sliderMaxValue - this.sliderMinValue)
        );

        if (this.isMinSlider(sliderNode)) {
            this.minSliderPosition = pos;

            // update ARIA attributes
            this.minSliderValueNode.textContent = dollarValue;
            this.maxSliderNode.setAttribute('aria-valuemin', value);

            // move the SVG focus ring and thumb elements
            x = pos - this.focusOffset - 1;
            this.minSliderFocusNode.setAttribute('x', x);

            points = `${pos},${this.thumbTop}`;
            points += ` ${pos + this.thumbWidth},${this.thumbMiddle}`;
            points += ` ${pos},${this.thumbBottom}`;
            this.minSliderThumbNode.setAttribute('points', points);

            // Position value
            width = this.minSliderValueNode.getBoundingClientRect().width;
            pos += (this.thumbWidth - width) / 2;
            if (pos + width > this.maxSliderLeft - 2) {
                pos = this.maxSliderLeft - width - 2;
            }
            this.minSliderValueNode.setAttribute('x', pos);
            this.minSliderRight = pos;
        } else {
            // update label and ARIA attributes
            this.maxSliderPosition = pos;

            this.maxSliderValueNode.textContent = dollarValue;
            this.minSliderNode.setAttribute('aria-valuemax', value);

            // move the SVG focus ring and thumb elements
            x = pos + this.thumbWidth - this.focusOffset + 1;
            this.maxSliderFocusNode.setAttribute('x', x);

            points = `${pos + this.thumbWidth},${this.thumbMiddle}`;
            points += ` ${pos + this.thumb2Width},${this.thumbTop}`;
            points += ` ${pos + this.thumb2Width},${this.thumbBottom}`;
            this.maxSliderThumbNode.setAttribute('points', points);

            width = Math.max(
                0,
                this.maxSliderValueNode.getBoundingClientRect().width
            );
            pos = pos + this.thumbWidth + (this.thumbWidth - width) / 2;
            if (pos - width < this.minSliderRight + 2) {
                pos = this.minSliderRight + width + 2;
            }

            this.maxSliderValueNode.setAttribute('x', pos);
            this.maxSliderLeft = pos;
        }

        // Set range rect

        x = this.getXFromThumb(this.minSliderThumbNode) + this.thumbWidth / 2;
        width =
            this.getXFromThumb(this.maxSliderThumbNode) - x + this.thumbWidth / 2;
        this.rangeNode.setAttribute('x', x);
        this.rangeNode.setAttribute('width', width);
    }

    onSliderKeydown(event) {
        let flag = false;
        const sliderNode = event.currentTarget;
        const value = this.getValue(sliderNode);
        const valueMin = this.getValueMin(sliderNode);
        const valueMax = this.getValueMax(sliderNode);

        switch (event.key) {
            case 'ArrowLeft':
            case 'ArrowDown':
                this.moveSliderTo(sliderNode, value - 1);
                flag = true;
                break;

            case 'ArrowRight':
            case 'ArrowUp':
                this.moveSliderTo(sliderNode, value + 1);
                flag = true;
                break;

            case 'PageDown':
                this.moveSliderTo(sliderNode, value - 10);
                flag = true;
                break;

            case 'PageUp':
                this.moveSliderTo(sliderNode, value + 10);
                flag = true;
                break;

            case 'Home':
                this.moveSliderTo(sliderNode, valueMin);
                flag = true;
                break;

            case 'End':
                this.moveSliderTo(sliderNode, valueMax);
                flag = true;
                break;

            default:
                break;
        }

        if (flag) {
            event.preventDefault();
            event.stopPropagation();
        }
    }

    onSliderFocus(event) {
        event.currentTarget.classList.add('focus');
        this.svgNode.classList.add('active');
    }

    onSliderBlur(event) {
        event.currentTarget.classList.remove('focus');
        this.svgNode.classList.remove('active');
    }

    onSliderPointerdown(event) {
        this.isMoving = true;
        this.movingSliderNode = event.currentTarget;
        this.isMinSliderMoving = this.isMinSlider(event.currentTarget);

        event.preventDefault();
        event.stopPropagation();

        // Set focus to the clicked handle
        this.movingSliderNode.focus();
    }

    onPointermove(event) {
        if (
            this.isMoving &&
            this.movingSliderNode &&
            this.domNode.contains(event.target)
        ) {
            let x = this.getSVGPoint(event).x - this.railX;
            if (this.isMinSliderMoving) {
                x = Math.max(0, x - this.thumbWidth / 3);
            } else {
                x = Math.max(0, x - (5 * this.thumbWidth) / 3);
            }
            x = Math.min(x, this.railWidth - this.thumbWidth);
            const value = Math.round(
                (x * this.sliderDiffValue) / (this.railWidth - this.thumbWidth)
            );
            this.moveSliderTo(this.movingSliderNode, value);

            event.preventDefault();
            event.stopPropagation();
        }
    }

    onPointerup() {
        this.isMoving = false;
        this.movingSliderNode = false;
    }

    // handle click event on the rail
    onRailClick(event) {
        const x = this.getSVGPoint(event).x - this.railX;
        const diffMin = x - this.minSliderPosition - (3 * this.thumbWidth) / 2;
        const diffMax = this.maxSliderPosition - x;
        const sliderNode =
            (x < this.minSliderPosition || diffMin < diffMax) &&
            x < this.maxSliderPosition
                ? this.minSliderNode
                : this.maxSliderNode;

        let p = Math.max(0, x - this.thumbWidth);
        p = Math.min(p, this.railWidth - this.thumbWidth);
        const value = Math.round(
            (p * this.sliderDiffValue) / (this.railWidth - this.thumbWidth)
        );

        this.moveSliderTo(sliderNode, value);

        event.preventDefault();
        event.stopPropagation();
    }
}

// Initialize Multithumb Slider widgets on the page
window.addEventListener('load', () => {
    const slidersMultithumb = document.querySelectorAll('.slider-multithumb');

    for (let i = 0; i < slidersMultithumb.length; i++) {
        new SliderMultithumb(slidersMultithumb[i]);
    }
});
